import moment from 'moment'

export const getDateMMMDDYYY = (value) => {
    if (value) {
        return moment(String(value)).format('MMM DD, YYYY')
    }
}
export const getAge = (value) => {
    if (value) {
        return moment().diff(moment(String(value), 'YYYYMMDD'), 'years')
    }
}
export const capitalizeAll = (value) => {
    if (value) {
        return String(value).toUpperCase()
    }
}
export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}